import React, { useState, useEffect, useContext } from "react";
import "./listing.css";
import Navbar from "../../components/navbar/Navbar";
import Banner from "../../components/banner/Banner";
import logo from "../../images/white-logo.png";
import Rightside from "../../components/rightside/Rightside";
import Gridpc from "../../components/grid/Gridpc";
import Filter from "../../components/filter/Filter";
import Footer from "../../components/footer/Footer";
import MobFilter from "../../components/Mobfilter/MobFilter";
import MobList from "../../components/Moblist/MobList";
import axios from "axios";
import SearchContext from "../../context/SearchContext";
import FooterMob from "../../components/footer/FooterMob";
import { baseUrl } from "../../context/BaseUrl";

import SideBarContext from "../../context/SideBarContext";
import { useParams } from "react-router-dom";
import MobNav from "../../components/Mobnav/MobNav";

const Listing = () => {
  const [Data, setData] = useState(false);
  const { search, setSearch } = useContext(SearchContext);
  const { adBanners } = useContext(SideBarContext);

  const { name, id } = useParams();

  async function fetchData() {
    const searchResponse = await fetch(`${baseUrl}/user/listing/filter`, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...search, category: id,
      }),
    });

    const result = await searchResponse.json();
    console.log(Data)
    setData(result);
  }
  
  useEffect(() => {
    fetchData();
  }, [search]);
  return (
    Data && (
      <React.Fragment>
        <MobNav />
        <div className="home-background">
          <Navbar logoimg={logo} />
        </div>
        <div className="listing-page">
          <a href={adBanners.page_banner.link}>
            <Banner bannerimg={adBanners.page_banner.banner} title="" />
          </a>

          <MobFilter category_id={id} />
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-8 col-md-7 col-sm-12 col-xs-12">
                <Filter category_id={id} />
                <div className="row">
                  {
                  Data.featured ? Data.featured.map((item, index) => (
                    <div key={index} className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <div className="mob-list featured">
                        <MobList
                          image={item.institute_id.image}
                          name={item.institute_id.name}
                          location={item.institute_id.location}
                          institute_id={item.institute_id.institute_id}
                          about={item.institute_id.about.length > 180 ? item.institute_id.about.slice(0, 180)+ "...." : item.institute_id.about }
                        />
                      </div>
                      <div className="pc-grid featured">
                        <Gridpc
                          image={item.institute_id.image}
                          name={item.institute_id.name}
                          location={item.institute_id.location}
                          institute_id={item.institute_id.institute_id}
                          about={`${item.institute_id.about.length > 100 ? item.institute_id.about.slice(0, 100)+ "...." : item.institute_id.about}`}
                        />
                      </div>
                    </div>
                  )) : ""}
                  {Data.institutes?.map((item) => (
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                      <div className="mob-list">
                        <MobList
                          image={item.image}
                          name={item.name}
                          location={item.location}
                          institute_id={item.institute_id}
                          about={item.about.slice(0, 100) + "..."}
                        />
                      </div>
                      <div className="pc-grid">
                        <Gridpc
                          image={item.image}
                          name={item.name}
                          location={item.location}
                          institute_id={item.institute_id}
                          about={item.about.slice(0, 180) + "..."}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="col-lg-4 col-md-5 col-sm-12 col-xs-12">
                <div className="rigthside p-0 p-sm-5">
                  <Rightside />
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
        <FooterMob />
      </React.Fragment>
    )
  );
};

export default Listing;
